import { OfflineLink } from '@quesmed/types-rn/utils';
import localforage from 'localforage';

export const offlineLink = new OfflineLink({
  storage: localforage,
  retryInterval: 5000,
  sequential: true,
  retryOnServerError: false,
});
